module.exports = __webpack_public_path__ + "img/logo.d6892f6.png";